import { Link } from 'react-router-dom';
import mascot from '../img/wreckoning-ball.png';
import appStoreBadge from '../img/Store=App Store, Type=Dark, Language=English@3x.png';
import googlePlayBadge from '../img/Store=Google Play, Type=Dark, Language=English@3x.png';

export default function SiteFooter() {
  return (
    <footer className="footer">
      <div className="content-well footer-inner">
        <div className="footer-top">
          <img className="footer-mascot" src={mascot} alt="" aria-hidden="true" />
          <p className="footer-top-tagline">The Ball has opinions and no accountability.</p>
          <div className="store-badges footer-badges">
            <a href="https://apps.apple.com/app/id6760224604" aria-label="Download on the App Store">
              <img src={appStoreBadge} alt="Download on the App Store" />
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.wreckoningball.app" aria-label="Get it on Google Play">
              <img src={googlePlayBadge} alt="Get it on Google Play" />
            </a>
          </div>
        </div>
        <div className="footer-divider" />
        <div className="footer-bottom">
          <p className="copyright">© {new Date().getFullYear()} Wreckoning Ball</p>
          <nav className="footer-links footer-bottom-links" aria-label="Legal">
            <Link to="/support">Support</Link>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-of-service">Terms of Service</Link>
            <Link to="/delete-account">Delete Account</Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}
